import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-superadmin-addsubcategory',
  templateUrl: './superadmin-addsubcategory.component.html',
  styleUrls: ['./superadmin-addsubcategory.component.css']
})

export class SuperadminAddsubcategoryComponent implements OnInit {

  @ViewChild('showeditmedsubcateModal', { static: true } as any) showeditmedsubcateModal: TemplateRef<any>;
  today = Utils.today;
  cate: any;
  selected: any;
  subcate: any;
  editmscstatus: any;
  editmscate: any;
  editmscateid: any;
  editmcate: any;
  editmcateid: any;


  constructor(
    private modal: NgbModal,
    private location: Location,
    private service: VproService,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
  ) { }
  create_med_sub_cate_form: UntypedFormGroup;
  editmedsubcateform: UntypedFormGroup;

  ngOnInit() {
    this.getMedicinecategory();
    //this.getMedicinecategory();


    this.create_med_sub_cate_form = this._formBuilder.group({

      med_cate_id: [''],
      med_sub_cate: ['', [Validators.required]],
      subcate_status: [''],
      created_at: [''],
      created_by: [''],

    })

    this.editmedsubcateform = this._formBuilder.group({

      med_sub_cate: ['', [Validators.required]],
      med_sub_cate_id: ['', [Validators.required]],
      med_cate_id: ['', [Validators.required]],
      sub_cate_status: [''],
      edited_at: [''],
      edited_by: [''],

    })


  }

  getback() {
    this.location.back();
  }

  //get the category
  getMedicinecategory() {

    this.service
      .getMedicinecategory()
      .subscribe(
        (res) => {
          //this.spinner.hide();
          this.cate = res;
          console.log("CATEGORY", this.cate);
        },
        (error) => {
          //this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }


  // save the medicine sub category
  createmedicinesubcategory() {


    let data = { ...this.create_med_sub_cate_form.value };
    data.med_cate_id = parseInt(data.med_cate_id);
    data.subcate_status = true;
    data.created_at = this.today;
    data.created_by = "Admin";

    console.log("medicine_sub_cate", data);


    this.service
      .addMedicinesubcategory({ medicine_sub_cate: [data] })
      .subscribe((result) => {
        window.location.reload();
        Utils.showToast("success", "Medicine Sub Category added successfully");
      });

    let medicine_sub_cate = [{ data }];
    // console.log("medicine_sub_cate", data);

  }

  onAccStatusChange = async (index, enable, subcatename) => {

    let data: any =
    {
      "med_sub_cate_id": index,
      "med_sub_cate": subcatename,
      "subcate_status": !enable,
      "edited_at": this.today,
      "edited_by": "ADMIN",

    };

    this.spinner.show();
    this.service.editMedsubcategory(data.med_sub_cate_id, data).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        Utils.showToast('success', "Sub-Category Deleted successfuly");
        //this.findPatient(this.page);
      },
      (error) => {
        //this.spinner.hide();
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update profile."
        Utils.showToast('error', message);
      }
    );

    //window.location.reload();

    //this.updateMedategoryStatus(data);
  }




  retriveSubcategory(e) {
    this.selected = e.target.value
    let subcatid = parseInt(this.selected);
    console.log(this.selected);

    this.service
      .retriveMedsubcate({ subcat: subcatid })
      .subscribe((result) => {

        this.subcate = result;
      })
    console.log(this.subcate)

  }


  // showeditmedsubcate(p?.med_cate, p?.med_sub_cate_id, p?.med_sub_cate_id, p?.subcate_status, p?.med_sub_cate)


  showeditmedsubcate(mcateid, mscateid, mscate, mscstatus) {

    //this.editmcate = mcate;
    this.editmcateid = mcateid;
    this.editmscateid = mscateid;
    this.editmscate = mscate;
    this.editmscstatus = mscstatus;

    //console.log("receved value from form", this.editmcate);
    console.log("receved value from form", this.editmcateid);
    console.log("receved value from form", this.editmscateid);
    console.log("receved value from form", this.editmscate);
    console.log("receved value from form", this.editmscstatus);

    // this.fetchservicereport(aid, pid);
    // console.log("showserviceRep   showserviceRep")
    this.editmedsubcateform.patchValue({
      med_cate: this.editmcate,
      med_cate_id: this.editmcateid,
      med_sub_cate: this.editmscate,
      med_sub_cate_id: this.editmscateid,
      subcate_status: this.editmscstatus,

    });


    this.modal.open(this.showeditmedsubcateModal, { size: 'lg', centered: true, backdrop: 'static' });

  }

  // update category name



  // cate_status  :   true
  // edited_at  :   Fri May 05 2023 11:26:08 GMT+0530 (India Standard Time) {}
  // edited_by  :   "Admin"
  // med_cate  :   undefined
  // med_cate_id  :   13
  // med_sub_cate  :   "wwww sub cate"
  // med_sub_cate_id  :   141
  // med_sub_cate_status  :   true

  updatesubcate() {

    let data = { ...this.editmedsubcateform.value };
    if (data.sub_cate_status === "") {

      data.subcate_status = true;
      delete data.sub_cate_status;
    }


    data.med_cate_id = parseInt(data.med_cate_id);
    data.edited_at = this.today;
    data.edited_by = "Admin";

    console.log("Aftter updated value", data);

    this.spinner.show();
    this.service.editMedsubcategory(data.med_sub_cate_id, data).subscribe(
      (res) => {
        this.spinner.hide();
        Utils.showToast('success', "Category Updated successfuly");
      },
      (error) => {
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update profile."
        Utils.showToast('error', message);
      }
    );




  }

}